const SELECTOR = '[data-nextwith-progressive-reader]';

function articleBlocks(root) {
  const article = root.closest('.nw-prose, .post-content') || document.querySelector('.nw-prose, .post-content');
  if (!article) return [];
  return [...article.querySelectorAll('p, h2, h3, li, blockquote')]
    .filter(node => !node.closest('[data-nextwith-progressive-reader]'))
    .filter(node => !node.closest('.nw-audio-brief'))
    .filter(node => node.textContent.trim().length >= 24);
}

function update(root, state, label, index, count) {
  root.dataset.nextwithReaderState = state;
  const status = root.querySelector('[data-nextwith-reader-status]');
  const progress = root.querySelector('[data-nextwith-reader-progress]');
  if (status) status.textContent = label;
  if (progress && count) progress.textContent = `Section ${index + 1} of ${count}`;
}

function setActive(blocks, index) {
  blocks.forEach((block, blockIndex) => block.classList.toggle('nw-reader-active', blockIndex === index));
}

function init(root) {
  if (root.dataset.nextwithReaderReady === 'true') return;
  root.dataset.nextwithReaderReady = 'true';
  const button = root.querySelector('[data-nextwith-reader-toggle]');
  const player = root.querySelector('[data-nextwith-reader-audio]');
  const blocks = articleBlocks(root);
  const endpoint = root.dataset.nextwithReaderEndpoint || '/api/reader-audio';
  let index = 0;
  let objectURL = '';
  let loading = false;
  let finished = false;

  if (!button || !player || !blocks.length) {
    update(root, 'error', 'Article reading is unavailable. Use the quick brief below.');
    return;
  }
  update(root, 'idle', 'Cedar reads one section at a time. The next section is requested only while you are here.', 0, blocks.length);

  const release = () => {
    if (objectURL) URL.revokeObjectURL(objectURL);
    objectURL = '';
  };
  const stop = () => {
    player.pause();
    release();
    setActive(blocks, -1);
  };
  const load = async nextIndex => {
    if (loading || finished || document.visibilityState !== 'visible' || !document.documentElement.contains(root)) return;
    loading = true;
    index = nextIndex;
    button.disabled = true;
    update(root, 'loading', `Preparing section ${index + 1}…`, index, blocks.length);
    try {
      const request = new URL(endpoint, window.location.origin);
      request.searchParams.set('article', window.location.pathname);
      request.searchParams.set('segment', String(index));
      const response = await fetch(request, {headers: {accept: 'audio/mpeg'}});
      if (!response.ok) throw new Error(`Reader request failed (${response.status})`);
      const count = Number(response.headers.get('x-nextwith-reader-sections'));
      if (Number.isInteger(count) && count > 0 && count < blocks.length) blocks.splice(count);
      release();
      objectURL = URL.createObjectURL(await response.blob());
      player.src = objectURL;
      setActive(blocks, index);
      await player.play();
      update(root, 'playing', `Reading section ${index + 1}.`, index, blocks.length);
      button.textContent = 'Pause reading';
    } catch {
      update(root, 'error', 'Article reading is unavailable. Use the quick brief below.', index, blocks.length);
      button.textContent = 'Listen to this article';
      setActive(blocks, -1);
    } finally {
      loading = false;
      button.disabled = false;
    }
  };

  button.addEventListener('click', () => {
    if (!player.paused) {
      player.pause();
      update(root, 'paused', `Paused at section ${index + 1}.`, index, blocks.length);
      button.textContent = 'Resume reading';
      return;
    }
    if (player.src && !finished) {
      player.play().then(() => {
        update(root, 'playing', `Reading section ${index + 1}.`, index, blocks.length);
        button.textContent = 'Pause reading';
      }).catch(() => update(root, 'error', 'Playback needs another tap to start.', index, blocks.length));
      return;
    }
    if (finished) { finished = false; index = 0; }
    load(index);
  });

  player.addEventListener('ended', () => {
    release();
    if (index + 1 >= blocks.length) {
      finished = true;
      setActive(blocks, -1);
      update(root, 'ended', 'Finished. Start again whenever you want.', blocks.length - 1, blocks.length);
      button.textContent = 'Listen again';
      return;
    }
    if (document.visibilityState === 'visible' && document.documentElement.contains(root)) load(index + 1);
    else {
      update(root, 'paused', `Paused after section ${index + 1}.`, index, blocks.length);
      button.textContent = 'Resume reading';
    }
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden' && !player.paused) {
      player.pause();
      update(root, 'paused', `Paused at section ${index + 1}.`, index, blocks.length);
      button.textContent = 'Resume reading';
    }
  });
  window.addEventListener('pagehide', stop, {once: true});
}

export function initProgressiveReader() {
  document.querySelectorAll(SELECTOR).forEach(init);
}
